import { useState } from "react"
import { ReactComponent as Checkmark } from "../../../assets/icons/checkmark.svg";
import { Button } from "../../../components/Button";
import { SALES_EXPERIENCE_OPTION_KEYS, SALES_EXPERIENCE_OPTIONS } from "./Step1";
import { useApp } from "../../../services/app-context";
import { SignedUrlImage } from "../../../components/SignedUrlImage";

const TOTAL_STEP = 1;

function BulletPoint({ text }: { text: string }) {
    return (
        <div className="flex items-start gap-2">

            <Checkmark className="mt-1 min-h-[18px] min-w-[18px] h-[18px] w-[18px]" />
            <div className="text-black text-sm font-normal opacity-60">{text}</div>
        </div>
    )
}
function SubStep1({ onContinue }: { onContinue: () => void }) {
    const { tenantProfile } = useApp()
    return (
        <div className="flex items-center gap-10 py-10 pl-10 pr-5">
            <div className="flex-[2]">
                <SignedUrlImage s3Key="onboarding-2.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
            </div>
            <div className="flex flex-col gap-4 flex-[3]">
                <div>
                    <div className="flex flex-col gap-2">
                        <span className="text-black text-[21px] font-bold ">Hey, us too!</span>
                    </div>
                    <p className="text-black text-sm font-normal opacity-60">After decades of industry experience, we developed PraxisPlay to...</p>
                    <div className="flex flex-col gap-[18px] mt-6">
                        <BulletPoint text="Give you control over your learning and development." />
                        <BulletPoint text="Create a safe space for you to develop your selling skills." />
                        <BulletPoint text="Push your skills to new heights through challenging role plays." />
                    </div>
                    <div className="mt-10 flex justify-end">
                        <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}


function SubStep2({ onContinue }: { onContinue: () => void }) {
    const { tenantProfile } = useApp()
    return (
        <div className="flex items-center gap-10 py-10 pl-10 pr-5">
            <div className="flex-[2]">
                <SignedUrlImage s3Key="onboarding-2.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
            </div>
            <div className="flex flex-col gap-4 flex-[3]">
                <div>
                    <div className="flex flex-col gap-2">
                        <span className="text-black text-[21px] font-bold ">Experienced and agile.</span>
                    </div>
                    <p className="text-black text-sm font-normal opacity-60">After decades of industry experience, we developed PraxisPlay to...</p>
                    <div className="flex flex-col gap-[18px] mt-6">
                        <BulletPoint text="Give you control over your learning and development." />
                        <BulletPoint text="Create a safe space for you to develop your selling skills." />
                        <BulletPoint text="Push your skills to new heights through challenging role plays." />
                    </div>
                    <div className="mt-10 flex justify-end">
                        <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                    </div>
                </div>
            </div>
        </div>
    )

}

function SubStep3({ onContinue }: { onContinue: () => void }) {
    const { tenantProfile } = useApp()
    return (<div className="flex items-center gap-10 py-10 pl-10 pr-5">
        <div className="flex-[2]">
            <SignedUrlImage s3Key="onboarding-2.svg" bucket={tenantProfile?.assets_bucket} alt="logo" className="w-[152px] h-[152px]" />
        </div>
        <div className="flex flex-col gap-4 flex-[3]">
            <div>
                <div className="flex flex-col gap-2 mb-2">
                    <span className="text-black text-[21px] font-bold ">Early Sales Career! <br />
                        We can relate.</span>
                </div>
                <p className="text-black text-sm font-normal opacity-60">In our early years of sales, we...</p>
                <div className="flex flex-col gap-[18px] mt-6">
                    <BulletPoint text="Struggled to find ways to practice." />
                    <BulletPoint text="Didn't want to bother our counterparts and sales leaders." />
                    <BulletPoint text="Wanted a way to own our learning and development." />
                </div>
                <div className="mt-10 flex justify-end">
                    <Button variant="primary" className="!rounded-full w-[136px] !h-[38px]" onClick={onContinue}>Continue</Button>
                </div>
            </div>
        </div>
    </div>
    )
}

const subSteps = {
    [SALES_EXPERIENCE_OPTION_KEYS["1_5_YEARS"]]: SubStep1,
    [SALES_EXPERIENCE_OPTION_KEYS["6_PLUS_YEARS"]]: SubStep2,
    [SALES_EXPERIENCE_OPTION_KEYS.JUST_STARTING_OUT]: SubStep3,
}

export function Step2({ onContinue, onboardingForm }: { onContinue: () => void, onboardingForm: any, setOnboardingForm: any }) {
    const [subStep, setSubStep] = useState(1);
    const Component = subSteps[onboardingForm?.sales_experience];

    const handleContinue = () => {
        if (subStep < TOTAL_STEP) {
            setSubStep(prev => prev + 1);
        } else {
            onContinue();
        }
    }
    return (
        <div>
            <Component onContinue={handleContinue} />
        </div>
    )
}